<template>
    <div class="bg-F6F7FA">
        <CCol sm="12">
    
    
            <CCol sm="12">
                <CCard class="p-2 custom-bg-card">
                    <CCol sm="12">
                        <CRow>
                            <CCol col="12" sm="6" lg="7">
                                <div class="d-flex">
                                    <CInput type="text" class="mr-2" placeholder="Search....."/>
                                </div>
                            </CCol>
                            <CCol col="12" sm="12" lg="5">
    <div class="text-right">
        <CRow>
            <CCol sm="12" class="d-flex justify-content-end">
                <CButton type="button" class="bg-white custom-bg-btn-white-border mr-2" @click="OpenAdd()">
                    <img src="../assets/image/iconCalendar.png" style="max-width:20px" class="mr-1" />This Week
                </CButton>

                <CButton type="button" class="bg-white custom-bg-btn-white-border mr-2">
                    <img src="../assets/image/sort.png" style="max-width:20px" class="mr-1" />Filter
                </CButton>

                <CButton class="bg-7F56D9 text-white border-16px" @click="OpenAdd()">
                    <img src="../assets/image/add.png" style="max-width:20px" class="mr-1" />Add Data
                </CButton>
            </CCol>
        </CRow>
    </div>
</CCol>

                        </CRow>
                    </CCol>
    
                    <div class="table-container">
                        <table class="table table-responsive-sm">
                            <thead class="custom-bg-header-table" style="border-bottom:none">
                                <tr style="border:none">
                                    <th style="border-radius: 10px var(--radius-none, 0px) var(--radius-none, 0px) 10px;"></th>
                                    <th>Pusat</th>
                                    <th>Tarikh Terima (Bajet)</th>
                                    <th>Tarikh Serahan Ke Unit</th>
                                    <th>Bil. Hari (Bajet)</th>
                                    <th>Jenis Dana (OE/DE/Dalaman)</th>
                                    <th>Nama Pembekal</th>
                                    <th>KENAAN AKAUN / RUJUKAN TANGGUNGAN</th>
                                    <th>JUMLAH (RM)</th>
                                    <th>SST</th>
                                    <th>JUMLAH BESAR (RM)</th>
                                    <th>PIC BAJET</th>
                                    <th>UNIT BERKAITAN</th>
                                    <th>TARIKH TERIMA (SPH)</th>
                                    <th>TARIKH DAFTAR (SPH)</th>
                                    <th>PIC SPH</th>
                                    <th>PIC UNIT BAYARAN</th>
                                    <th>TARIKH DOKUMEN LENGKAP</th>
                                    <th>CATATAN</th>
                                    <th>TARIKH LULUS BAUCER</th>
                                    <th>CARA BAYARAN (EFT / CEK / BANK DRAF)</th>
                                    <th>TARIKH BAYARAN</th>
                                    <th>BAYARAN SELESAI (HARI)</th>
                                    <th>Status</th>
<th style="border-radius: var(--radius-none, 0px) 10px 10px var(--radius-none, 0px);
background: var(--colors-gray-light-mode-100, #F2F4F7);">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><input type="checkbox" /></td>
                                    <td>PUSAT</td>
                                    <td>08/11/2024</td>
                                    <td>08/11/2024</td>
                                    <td>234/BJ/2024</td>
                                    <td>OE</td>
                                    <td>Syarikat ABC Sdn Bhd</td>
                                    <td>Pembelian Alat Tulis</td>
                                    <td>1,000</td>
                                    <td>6</td>
                                    <td>1050</td>
                                    <td>Mohd Ali	</td>
                                    <td>Unit Kewangan</td>
                                    <td>01/09/2024</td>

                                    <td>02/09/2024</td>
                                    <td>Nur Aiman	</td>
                                    <td>Ahmad Syukri</td>
                                    <td>03/09/2024	</td>
                                    <td>-</td>
                                    <td>05/09/2024	</td>
                                    <td>EFT</td>
                                    <td>07/09/2024	</td>
                                    <td>6</td>
                                    <td><span class="custom-orange-half"><input type="radio" />Pending</span></td>
                                    <td>
                                        <img src="../assets/image/Delete.png" width="22px" class="mr-2"/>
                                         <img src="../assets/image/edit-grey.png" width="20px" @click="openEdit()"/></td>
                                    <!-- Additional columns as needed -->
                                </tr>
                                <tr>
                                    <td><input type="checkbox" /></td>
                                    <td>PUSAT</td>
                                    <td>08/11/2024</td>
                                    <td>08/11/2024</td>
                                    <td>234/BJ/2024</td>
                                    <td>OE</td>
                                    <td>Syarikat ABC Sdn Bhd</td>
                                    <td>Pembelian Alat Tulis</td>
                                    <td>1,000</td>
                                    <td>6</td>
                                    <td>1050</td>
                                    <td>Mohd Ali	</td>
                                    <td>Unit Kewangan</td>
                                    <td>01/09/2024</td>

                                    <td>02/09/2024</td>
                                    <td>Nur Aiman	</td>
                                    <td>Ahmad Syukri</td>
                                    <td>03/09/2024	</td>
                                    <td>-</td>
                                    <td>05/09/2024	</td>
                                    <td>EFT</td>
                                    <td>07/09/2024	</td>
                                    <td>6</td>
                                    <td><span class="custom-success-half"><input type="radio" />Success</span></td>
                                    <td>
                                        <img src="../assets/image/Delete.png" width="22px" class="mr-2"/>
                                         <img src="../assets/image/edit-grey.png" width="20px" @click="openEdit()"/></td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" /></td>
                                    <td>PUSAT</td>
                                    <td>08/11/2024</td>
                                    <td>08/11/2024</td>
                                    <td>234/BJ/2024</td>
                                    <td>OE</td>
                                    <td>Syarikat ABC Sdn Bhd</td>
                                    <td>Pembelian Alat Tulis</td>
                                    <td>1,000</td>
                                    <td>6</td>
                                    <td>1050</td>
                                    <td>Mohd Ali	</td>
                                    <td>Unit Kewangan</td>
                                    <td>01/09/2024</td>

                                    <td>02/09/2024</td>
                                    <td>Nur Aiman	</td>
                                    <td>Ahmad Syukri</td>
                                    <td>03/09/2024	</td>
                                    <td>-</td>
                                    <td>05/09/2024	</td>
                                    <td>EFT</td>
                                    <td>07/09/2024	</td>
                                    <td>6</td>
                                    <td><span class="custom-orange-half"><input type="radio" />Pending</span></td>
                                    <td>
                                        <img src="../assets/image/Delete.png" width="22px" class="mr-2"/>
                                         <img src="../assets/image/edit-grey.png" width="20px" @click="openEdit()"/></td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" /></td>
                                    <td>PUSAT</td>
                                    <td>08/11/2024</td>
                                    <td>08/11/2024</td>
                                    <td>234/BJ/2024</td>
                                    <td>OE</td>
                                    <td>Syarikat ABC Sdn Bhd</td>
                                    <td>Pembelian Alat Tulis</td>
                                    <td>1,000</td>
                                    <td>6</td>
                                    <td>1050</td>
                                    <td>Mohd Ali	</td>
                                    <td>Unit Kewangan</td>
                                    <td>01/09/2024</td>

                                    <td>02/09/2024</td>
                                    <td>Nur Aiman	</td>
                                    <td>Ahmad Syukri</td>
                                    <td>03/09/2024	</td>
                                    <td>-</td>
                                    <td>05/09/2024	</td>
                                    <td>EFT</td>
                                    <td>07/09/2024	</td>
                                    <td>6</td>
                                    <td><span class="custom-orange-half"><input type="radio" />Pending</span></td>
                                    <td>
                                        <img src="../assets/image/Delete.png" width="22px" class="mr-2"/>
                                         <img src="../assets/image/edit-grey.png" width="20px" @click="openEdit()"/></td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" /></td>
                                    <td>PUSAT</td>
                                    <td>08/11/2024</td>
                                    <td>08/11/2024</td>
                                    <td>234/BJ/2024</td>
                                    <td>OE</td>
                                    <td>Syarikat ABC Sdn Bhd</td>
                                    <td>Pembelian Alat Tulis</td>
                                    <td>1,000</td>
                                    <td>6</td>
                                    <td>1050</td>
                                    <td>Mohd Ali	</td>
                                    <td>Unit Kewangan</td>
                                    <td>01/09/2024</td>

                                    <td>02/09/2024</td>
                                    <td>Nur Aiman	</td>
                                    <td>Ahmad Syukri</td>
                                    <td>03/09/2024	</td>
                                    <td>-</td>
                                    <td>05/09/2024	</td>
                                    <td>EFT</td>
                                    <td>07/09/2024	</td>
                                    <td>6</td>
                                    <td><span class="custom-orange-half"><input type="radio" />Pending</span></td>
                                    <td>
                                        <img src="../assets/image/Delete.png" width="22px" class="mr-2"/>
                                         <img src="../assets/image/edit-grey.png" width="20px" @click="openEdit()"/></td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" /></td>
                                    <td>PUSAT</td>
                                    <td>08/11/2024</td>
                                    <td>08/11/2024</td>
                                    <td>234/BJ/2024</td>
                                    <td>OE</td>
                                    <td>Syarikat ABC Sdn Bhd</td>
                                    <td>Pembelian Alat Tulis</td>
                                    <td>1,000</td>
                                    <td>6</td>
                                    <td>1050</td>
                                    <td>Mohd Ali	</td>
                                    <td>Unit Kewangan</td>
                                    <td>01/09/2024</td>

                                    <td>02/09/2024</td>
                                    <td>Nur Aiman	</td>
                                    <td>Ahmad Syukri</td>
                                    <td>03/09/2024	</td>
                                    <td>-</td>
                                    <td>05/09/2024	</td>
                                    <td>EFT</td>
                                    <td>07/09/2024	</td>
                                    <td>6</td>
                                    <td><span class="custom-orange-half"><input type="radio" />Pending</span></td>
                                    <td>
                                        <img src="../assets/image/Delete.png" width="22px" class="mr-2"/>
                                         <img src="../assets/image/edit-grey.png" width="20px" @click="openEdit()"/></td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" /></td>
                                    <td>PUSAT</td>
                                    <td>08/11/2024</td>
                                    <td>08/11/2024</td>
                                    <td>234/BJ/2024</td>
                                    <td>OE</td>
                                    <td>Syarikat ABC Sdn Bhd</td>
                                    <td>Pembelian Alat Tulis</td>
                                    <td>1,000</td>
                                    <td>6</td>
                                    <td>1050</td>
                                    <td>Mohd Ali	</td>
                                    <td>Unit Kewangan</td>
                                    <td>01/09/2024</td>

                                    <td>02/09/2024</td>
                                    <td>Nur Aiman	</td>
                                    <td>Ahmad Syukri</td>
                                    <td>03/09/2024	</td>
                                    <td>-</td>
                                    <td>05/09/2024	</td>
                                    <td>EFT</td>
                                    <td>07/09/2024	</td>
                                    <td>6</td>
                                    <td><span class="custom-orange-half"><input type="radio" />Pending</span></td>
                                    <td>
                                        <img src="../assets/image/Delete.png" width="22px" class="mr-2"/>
                                         <img src="../assets/image/edit-grey.png" width="20px" @click="openEdit()"/></td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" /></td>
                                    <td>PUSAT</td>
                                    <td>08/11/2024</td>
                                    <td>08/11/2024</td>
                                    <td>234/BJ/2024</td>
                                    <td>OE</td>
                                    <td>Syarikat ABC Sdn Bhd</td>
                                    <td>Pembelian Alat Tulis</td>
                                    <td>1,000</td>
                                    <td>6</td>
                                    <td>1050</td>
                                    <td>Mohd Ali	</td>
                                    <td>Unit Kewangan</td>
                                    <td>01/09/2024</td>

                                    <td>02/09/2024</td>
                                    <td>Nur Aiman	</td>
                                    <td>Ahmad Syukri</td>
                                    <td>03/09/2024	</td>
                                    <td>-</td>
                                    <td>05/09/2024	</td>
                                    <td>EFT</td>
                                    <td>07/09/2024	</td>
                                    <td>6</td>
                                    <td><span class="custom-orange-half"><input type="radio" />Pending</span></td>
                                    <td>
                                        <img src="../assets/image/Delete.png" width="22px" class="mr-2"/>
                                         <img src="../assets/image/edit-grey.png" width="20px" @click="openEdit()"/></td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" /></td>
                                    <td>PUSAT</td>
                                    <td>08/11/2024</td>
                                    <td>08/11/2024</td>
                                    <td>234/BJ/2024</td>
                                    <td>OE</td>
                                    <td>Syarikat ABC Sdn Bhd</td>
                                    <td>Pembelian Alat Tulis</td>
                                    <td>1,000</td>
                                    <td>6</td>
                                    <td>1050</td>
                                    <td>Mohd Ali	</td>
                                    <td>Unit Kewangan</td>
                                    <td>01/09/2024</td>

                                    <td>02/09/2024</td>
                                    <td>Nur Aiman	</td>
                                    <td>Ahmad Syukri</td>
                                    <td>03/09/2024	</td>
                                    <td>-</td>
                                    <td>05/09/2024	</td>
                                    <td>EFT</td>
                                    <td>07/09/2024	</td>
                                    <td>6</td>
                                    <td><span class="custom-orange-half"><input type="radio" />Pending</span></td>
                                    <td>
                                        <img src="../assets/image/Delete.png" width="22px" class="mr-2"/>
                                         <img src="../assets/image/edit-grey.png" width="20px" @click="openEdit()"/></td>
                                </tr>
                                <!-- Additional rows -->
                            </tbody>
                        </table>
                    </div>
                </CCard>
            </CCol>
    
        </CCol>

        <div v-if="isEditData" class="popup-all backdrop-all">
            <div class="popup-all2">
                <!-- Popup content -->
                <CRow>
                    <CCol sm="11">
                        <h3 class="custom-20px-600">Table Details</h3>
                    </CCol>
                    <CCol sm="1">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closeEdit" />
                    </CCol>
                    <CCol sm="12" class="p-0">
                        <hr class="custom-hr" />
                    </CCol>
                   
                    <CCol sm="6" class="mt-2" style="border-right:1px solid #eee">
                        <CRow>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">PUSAT</h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">Mara HQ & Mara branch</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">TARIKH TERIMA (BAJET)</h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">01/09/2024	</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">TARIKH SERAHAN KE UNIT</h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">03/09/2024	</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">BIL. HARI (BAJET)</h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">234/BJ/2024</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">JENIS DANA (OE/DE/DALAMAN)</h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">OE</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">JENIS DANA (OE/DE/DALAMAN)</h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">Syarikat ABC Sdn Bhd	</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">NAMA PEMBEKAL</h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">Pembelian Alat Tulis	</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">KENAAN AKAUN / RUJUKAN TANGGUNGAN</h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">Pembelian Alat Tulis	</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">JUMLAH (RM) </h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">1,000</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>

                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">SST </h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">6</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>

                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">JUMLAH BESAR (RM)  </h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">1060</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>

                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">PIC BAJET </h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">Mohd Ali	</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>

                        </CRow>
                    </CCol>
                    <CCol sm="6" class="mt-2">
                        <CRow>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">UNIT BERKAITAN </h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">Unit Kewangan</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373"> TARIKH TERIMA (SPH) </h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">01/09/2024</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373"> TARIKH DAFTAR (SPH) </h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">02/09/2024</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373"> PIC SPH </h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">Nur Aiman	</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">PIC UNIT BAYARAN</h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">Ahmad Syukri</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">TARIKH DOKUMEN LENGKAP</h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">03/09/2024	</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">CATATAN</h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">-</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373"> TARIKH LULUS BAUCER </h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">05/09/2024	</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373"> CARA BAYARAN (EFT / CEK / BANK DRAF) </h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">EFT</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>

                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">TARIKH BAYARAN </h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">07/09/2024	</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>

                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373"> BAYARAN SELESAI (HARI) </h3>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-right">6</h3>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>

                            <CCol sm="4">
                                <h3 class="custom-14px-400 font-color-737373">Status </h3>
                            </CCol>
                            <CCol sm="8">
                                <CRow>
                                    <span class="custom-danger-half mr-1"><input type="radio" />Cancel</span>
                                    <span class="custom-orange-half mr-1"><input type="radio" />Pending</span>
                                    <span class="custom-success-half"><input type="radio" />Success</span>
                                    
                                </CRow>
                                
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="12" class="text-right">
                                <CButton class="bg-white mr-2 font-color-7F56D9">Delete</CButton>
                                <CButton class="bg-7F56D9 text-white" @click="OpenAdd()">Save Changes</CButton>
                            </CCol>

                        </CRow>
                    </CCol>
                </CRow>
            </div>
        </div>

        <div v-if="isAddData" class="popup-all backdrop-all">
            <div class="popup-all2">
                <!-- Popup content -->
                <CRow>
                    <CCol sm="11">
                        <h3 class="custom-20px-600">Table Details</h3>
                    </CCol>
                    <CCol sm="1">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closeAdd" />
                    </CCol>
                    <CCol sm="12" class="p-0">
                        <hr class="custom-hr" />
                    </CCol>
                   
                    <CCol sm="6" class="mt-2" style="border-right:1px solid #eee">
                        <CRow>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">PUSAT</h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">TARIKH TERIMA (BAJET)</h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">TARIKH SERAHAN KE UNIT</h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">BIL. HARI (BAJET)</h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">JENIS DANA (OE/DE/DALAMAN)</h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">JENIS DANA (OE/DE/DALAMAN)</h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">NAMA PEMBEKAL</h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">KENAAN AKAUN / RUJUKAN TANGGUNGAN</h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">JUMLAH (RM) </h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>

                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">SST </h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>

                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">JUMLAH BESAR (RM)  </h3>
                            </CCol>
                            <CCol sm="6">
                                <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>

                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">PIC BAJET </h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>

                        </CRow>
                    </CCol>
                    <CCol sm="6" class="mt-2">
                        <CRow>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">UNIT BERKAITAN </h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373"> TARIKH TERIMA (SPH) </h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373"> TARIKH DAFTAR (SPH) </h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373"> PIC SPH </h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">PIC UNIT BAYARAN</h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">TARIKH DOKUMEN LENGKAP</h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">CATATAN</h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373"> TARIKH LULUS BAUCER </h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373"> CARA BAYARAN (EFT / CEK / BANK DRAF) </h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>

                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373">TARIKH BAYARAN </h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>

                            <CCol sm="6">
                                <h3 class="custom-14px-400 font-color-737373"> BAYARAN SELESAI (HARI) </h3>
                            </CCol>
                            <CCol sm="6">
                               <input type="text" placeholder="Type here...." class="custom-transparent-input text-right"/>
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>

                            <CCol sm="4">
                                <h3 class="custom-14px-400 font-color-737373">Status </h3>
                            </CCol>
                            <CCol sm="8">
                                <CRow>
                                    <span class="custom-danger-half mr-1"><input type="radio" />Cancel</span>
                                    <span class="custom-orange-half mr-1"><input type="radio" />Pending</span>
                                    <span class="custom-success-half"><input type="radio" />Success</span>
                                    
                                </CRow>
                                
                            </CCol>
                            <CCol sm="12">
                                <hr />
                            </CCol>
                            <CCol sm="12" class="text-right">
                                <CButton class="bg-white mr-2 font-color-7F56D9">Cancel</CButton>
                                <CButton class="bg-7F56D9 text-white" @click="OpenAdd()">Add Data</CButton>
                            </CCol>

                        </CRow>
                    </CCol>
                </CRow>
            </div>
        </div>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import { CChartDoughnut } from '@coreui/vue-chartjs'
import { CChartBar } from '@coreui/vue-chartjs'

import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';

export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        CChartDoughnut,
        CChartBar,
        VueCal

    },

    data() {
        return {
           
            isEditData: false,
            isAddData:false
        }





    },
    async mounted() {
        // try {
        //     const isAuth = await this.UserAuth();
        //     if (isAuth) {

        //         this.GetDetailTotalCandidate();
        //         this.GetTotalCandidate();
        //         this.GetValueCategoryChart();
        //     } else {
        //         this.GoToPage();
        //     }
        // } catch (error) {
        //     this.GoToPage();
        //     console.error("Error during authentication:", error);
        //     // Handle the error here
        // }

    },

    computed: {
        filteredList() {
            const query = this.searchQuery.toLowerCase().trim();
            if (!query) {
                return this.list;
            } else {
                return this.list.filter(item => {
                    // Adjust the condition based on your search criteria
                    return item.name.toLowerCase().includes(query);
                });
            }
        },

    },

    methods: {
openEdit()
{
    this.isEditData = true;
},
closeEdit()
{
    this.isEditData = false;
},
OpenAdd()
{
    this.isAddData = true;
},
closeAdd()
{
    this.isAddData = false;
},


    }

};
</script>